import { render } from "./MountingPoiRecordView.vue?vue&type=template&id=5176c8dc&scoped=true"
import script from "./MountingPoiRecordView.vue?vue&type=script&lang=js"
export * from "./MountingPoiRecordView.vue?vue&type=script&lang=js"

import "./MountingPoiRecordView.vue?vue&type=style&index=0&id=5176c8dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5176c8dc"]])

export default __exports__